import { last } from "shared/lib/arrayUtils"

export function getFileExtension(fileName: string): string {
  const parts = fileName.split(".")
  if (parts.length === 1 || (parts[0] === "" && parts.length === 2)) {
    return ""
  }
  return last(parts).toLowerCase()
}

export function getFileNameWithoutExtension(fileName: string): string {
  const parts = fileName.split(".")
  if (parts.length === 1 || (parts[0] === "" && parts.length === 2)) {
    return fileName
  }
  return parts.slice(0, -1).join(".")
}
